// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__2qvZz","topBottomGutter":"Layout_topBottomGutter__2OBYw"};